module.exports = __webpack_public_path__ + "static/media/EmptyClients.5e1db52c.png";